[
   {
      "display":"true",
      "ui_columnname":"Failure code",
      "db_columnname":"failureCode",
      "datatype":"String",
      "mappingkey":"failureCode",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Failure Description",
      "db_columnname":"failureDescription",
      "datatype":"String",
      "mappingkey":"failureDescription",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Type",
      "db_columnname":"type",
      "datatype":"String",
      "mappingkey":"type",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Symbol",
      "db_columnname":"symbol",
      "datatype":"String",
      "mappingkey":"symbol",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"OrderID",
      "db_columnname":"orderID",
      "datatype":"String",
      "mappingkey":"orderID",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Order Date",
      "db_columnname":"orderKeyDate",
      "datatype":"String",
      "mappingkey":"orderKeyDate",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Side",
      "db_columnname":"side",
      "datatype":"String",
      "mappingkey":"side",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
        "display": "true",
        "ui_columnname": "Receiver IMID",
        "db_columnname": "receiverIMID",
        "datatype": "String",
        "mappingkey": "receiverIMID",
        "dropdown": "NO",
        "isdefault": "false",
        "disabled": "false",
        "value": "",
        "dropdownvalue": ""
    },
   {
      "display":"true",
      "ui_columnname":"Quantity",
      "db_columnname":"quantity",
      "datatype":"String",
      "mappingkey":"quantity",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Destination",
      "db_columnname":"destination",
      "datatype":"String",
      "mappingkey":"destination",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Routed OrderID",
      "db_columnname":"routedOrderID",
      "datatype":"String",
      "mappingkey":"routedOrderID",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"Sender IMID",
      "db_columnname":"senderIMID",
      "datatype":"String",
      "mappingkey":"senderIMID",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   },
   {
      "display":"true",
      "ui_columnname":"EventTimeStamp",
      "db_columnname":"eventTimestamp",
      "datatype":"String",
      "mappingkey":"eventTimestamp",
      "dropdown":"NO",
      "isdefault":"false",
      "disabled":"false",
      "value":"",
      "dropdownvalue":""
   }
]